package com.vizio.redwolf.auth.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
class AccountRefreshTokenInfo(@SerialName("refreshToken") val refreshToken: String)


@Serializable
class AccountEmailExistsRequestBody(@SerialName("email") val email: String,
                                    @SerialName("reCaptchaToken") val reCaptchaToken: String? = null)

@Serializable
class AccountEmailExistsSDKRequestBody(@SerialName("email") val email: String,
                                       @SerialName("reCaptchaToken") val reCaptchaToken: String? = null,
                                       @SerialName("messageToken") val messageToken: String? = null)

@Serializable
class AccountForgotPasswordInfo(@SerialName("email") val email: String,
                                @SerialName("reCaptchaToken") val reCaptchaToken: String? = null)

@Serializable
class AccountForgotPasswordSDKInfo(@SerialName("email") val email: String,
                                   @SerialName("reCaptchaToken") val reCaptchaToken: String? = null,
                                   @SerialName("messageToken") val messageToken: String? = null)


@Serializable
data class UpdatePasswordInfo(
    val oldPassword: String,
    val newPassword: String,
)